import { useTenantConfig } from '../contexts';

export const useFormatNumber = () => {
  const { numberDisplayFormat } = useTenantConfig();
  const formatNumber = (number: number) => {
    if (!numberDisplayFormat) {
      return undefined;
    } else {
      // split decimal part
      const part = number.toString().split('.');
      // add thousand separator
      let res = part[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        numberDisplayFormat.thousandSeparator,
      );
      // add decimal separator
      if (part[1]) res = res + numberDisplayFormat.decimalSeparator + part[1];
      return res;
    }
  };

  return formatNumber;
};
